import { collection, addDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { db } from "./config";

/**
 * Save contact form data to Firestore
 * @param {Object} contactData - The contact form data
 * @param {string} contactData.name - User's name
 * @param {string} contactData.email - User's email
 * @param {string} contactData.subject - Message subject
 * @param {string} contactData.message - Message content
 * @returns {Promise<string>} - Document ID of the saved contact
 */
export const saveContactForm = async (contactData) => {
  try {
    const contactsCollection = collection(db, "contacts");
    
    const docRef = await addDoc(contactsCollection, {
      name: contactData.name,
      email: contactData.email,
      subject: contactData.subject,
      message: contactData.message,
      timestamp: serverTimestamp(),
      status: "new", // Can be used to track if the contact has been responded to
      source: "website_contact_form"
    });
    
    console.log("Contact form saved with ID: ", docRef.id);
    return docRef.id;
  } catch (error) {
    console.error("Error saving contact form: ", error);
    throw new Error("Failed to save contact form. Please try again.");
  }
};

/**
 * Get all contacts from Firestore (for admin use)
 * @returns {Promise<Array>} - Array of contact documents
 */
export const getAllContacts = async () => {
  try {
    const contactsCollection = collection(db, "contacts");
    const contactSnapshot = await getDocs(contactsCollection);
    const contactList = contactSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return contactList;
  } catch (error) {
    console.error("Error fetching contacts: ", error);
    throw new Error("Failed to fetch contacts.");
  }
};
